export type NodeParameter = {
	name: string
	type: string
	required: boolean
	value: unknown
}

type InputParameterConfig = {
	type?: string
	required?: boolean
	value?: unknown
}

export const resolveNodeParameters = (
	inputs: Record<string, InputParameterConfig> | undefined,
): NodeParameter[] => {
	return Object.entries(inputs ?? {}).map(([name, config]) => ({
		name,
		type: config.type ?? "unknown",
		required: config.required ?? false,
		value: config.value,
	}))
}
